module.exports = __webpack_public_path__ + "img/location-dot-slash.c65e600c.svg";